import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { CajaService } from "../caja.service";

@Component({
  selector: "app-caja-modal",
  templateUrl: "./modal.component.html",
})
export class CajaModalComponent implements OnInit {
  public defaults?: any = undefined;
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Razon",
      property: "Razon",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Registrada el",
      property: "FechaRegistro",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Entrada",
      property: "Entrada",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Salida",
      property: "Salida",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Saldo",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: CajaService,
    public dialogRef: MatDialogRef<CajaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.getHistorial(this.data.IdTrabajador).subscribe(
      (resultData) => {
        this.tableComp.setData(resultData);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
